import axios from 'axios'
import moment from 'moment'
import {getTokenFromLocalStorage, clearTokenFromLocalStorage, setTokenFromLocalStorage} from './../helpers/token'
const BASE_NAME = "/cms/bac/api" // /cms/bac/api
const tokenQS = '?token='+getTokenFromLocalStorage()

export const CLOSE_SNACKBAR = "CLOSE_SNACKBAR"

export const closeSnackbar = () => {
	return {
		type: CLOSE_SNACKBAR
	}
}

export const OPEN_SNACKBAR = "OPEN_SNACKBAR"

export const openSnackbar = (message) => {
	return {
		type: OPEN_SNACKBAR,
		message
	}
}

export const CLOSE_PROGRESS = "CLOSE_PROGRESS"

export const closeProgress = () => {
	return {
		type: CLOSE_PROGRESS
	}
}

export const OPEN_PROGRESS = "OPEN_PROGRESS"

export const openProgress = (message) => {
	return {
		type: OPEN_PROGRESS,
		message
	}
}

export const login = (data) => (dispatch) => {
	let formData = new FormData();
	formData.append('username', data.username)
	formData.append('password', data.password)
	dispatch(openProgress('Logging In..'))
	return new Promise((resolve, reject) =>
	{
		axios.post(BASE_NAME+'/login', formData)
			.then(function (response) {
				dispatch(closeProgress())
				if(response.data.status === 'success') {
					setTokenFromLocalStorage(response.data.token)
					alert('Logged-in successfully.')
					resolve()
				}
				else {
					alert('Username/Password Incorrect.')
					reject()
				}
			})
			.catch(function (error) {
				dispatch(closeProgress())
				alert('Failed to  logged-in.')
				reject()
				console.log(error)
			})
	})
}

export const logout = (data) => (dispatch) => {
	clearTokenFromLocalStorage();
}


export const RECEIVE_PROCUREMENTS = 'RECEIVE_PROCUREMENTS'

export const receiveProcurements = (procurements) => {
	return {
		type: RECEIVE_PROCUREMENTS,
		procurements
	}
}

export const fetchProcurements = () => (dispatch) => {
	dispatch(openProgress('Fetching Procurements..'))
	return new Promise((resolve, reject) =>
	{
		axios.get(BASE_NAME+'/procurements'+tokenQS)
			.then(function (response) {
				dispatch(closeProgress())
				if(response.data.status === 'success') {
					dispatch(receiveProcurements(response.data.data))
					resolve()
				}
				else {
					reject()
				}
			})
			.catch(function (error) {
				dispatch(closeProgress())
				reject()
				console.log(error)
			})
	})
}

export const saveProcurement = (data) => (dispatch) => {
	let formData = new FormData();
	formData.append('project', data.project)
	formData.append('pr_number', data.pr_number)
	formData.append('category', data.category)
	formData.append('date', moment(data.date).format('YYYY-MM-DD'))
	formData.append('post_until', moment(data.post_until).format('YYYY-MM-DD'))
	formData.append('file', data.file)
	dispatch(openProgress('Saving Procurement..'))
	return new Promise((resolve, reject) =>
	{
		axios.post(BASE_NAME+'/procurements'+tokenQS, formData)
			.then(function (response) {
				dispatch(closeProgress())
				if(response.data.status === 'success') {
					dispatch(openSnackbar('Procurement successfully saved.'))
					resolve()
				}
				else {
					dispatch(openSnackbar('Failed to save Procurement.'))
					reject()
				}
			})
			.catch(function (error) {
				dispatch(closeProgress())
				dispatch(openSnackbar('Failed to save Procurement.'))
				reject()
				console.log(error)
			})
	})
}


export const updateProcurement = (data) => (dispatch) => {
	let formData = new FormData();
	formData.append('id', data.id)
	formData.append('project', data.project)
	formData.append('pr_number', data.pr_number)
	formData.append('category', data.category)
	formData.append('date', moment(data.date).format('YYYY-MM-DD'))
	formData.append('post_until', moment(data.post_until).format('YYYY-MM-DD'))
	formData.append('file', data.file)
	dispatch(openProgress('Updating Procurement..'))
	return new Promise((resolve, reject) =>
	{
		axios.post(BASE_NAME+'/updateprocurement'+tokenQS, formData)
			.then(function (response) {
				dispatch(closeProgress())
				if(response.data.status === 'success') {
					dispatch(openSnackbar('Procurement successfully updated.'))
					resolve()
				}
				else {
					dispatch(openSnackbar('Failed to update Procurement.'))
					reject()
				}
			})
			.catch(function (error) {
				dispatch(closeProgress())
				dispatch(openSnackbar('Failed to update Procurement.'))
				reject()
				console.log(error)
			})
	})
}

export const deleteProcurement = (data) => (dispatch) => {
	let formData = new FormData();
	formData.append('id', data.id)
	dispatch(openProgress('Deleting Procurement..'))
	return new Promise((resolve, reject) =>
	{
		axios.post(BASE_NAME+'/deleteprocurement'+tokenQS, formData)
			.then(function (response) {
				dispatch(closeProgress())
				if(response.data.status === 'success') {
					dispatch(openSnackbar('Procurement successfully deleted.'))
					resolve()
				}
				else {
					dispatch(openSnackbar('Failed to delete Procurement.'))
					reject()
				}
			})
			.catch(function (error) {
				dispatch(closeProgress())
				dispatch(openSnackbar('Failed to delete Procurement.'))
				reject()
				console.log(error)
			})
	})
}


// WEBPACK FOOTER //
// ./src/actions/index.js